import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hr-report',
  templateUrl: './hr-report.component.html',
  styleUrls: ['./hr-report.component.css']
})
export class HrReportComponent implements OnInit {
    page: string;

  constructor() { }

  ngOnInit() {
      this.page =  "overview" ;
  }

}



// WEBPACK FOOTER //
// ./src/app/hr-report.component.ts